import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = {
  key: 0,
  class: "vehicle-location has-modal"
}
const _hoisted_3 = { class: "vehicle-location--map" }
const _hoisted_4 = { class: "vehicle-location--controls" }
const _hoisted_5 = { class: "vehicle-location--controls-driver-image" }
const _hoisted_6 = { class: "vehicle-location--controls-driver-info" }
const _hoisted_7 = { class: "vehicle-location--controls-driver-info-name" }
const _hoisted_8 = { class: "vehicle-location--controls-driver-info-phone" }
const _hoisted_9 = { class: "vehicle-location--controls-driver-call-btn btn-xs" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "vehicle-location--booking-details" }
const _hoisted_12 = { class: "vehicle-location--booking-details-address" }
const _hoisted_13 = { class: "vehicle-location--booking-details-address-vehicle" }
const _hoisted_14 = { class: "vehicle-location--booking-details-address-vehicle-image" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "vehicle-location--booking-details-address-vehicle-class" }
const _hoisted_17 = { class: "vehicle-location--booking-details-address-statuses" }
const _hoisted_18 = { class: "vehicle-location--booking-details-address-vehicle-price" }
const _hoisted_19 = { class: "vehicle-location--booking-details-address-info" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Pick up address", -1)
const _hoisted_22 = { class: "form-control-value" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Dropoff address", -1)
const _hoisted_26 = { class: "form-control-value" }
const _hoisted_27 = { class: "vehicle-location--booking-details-notes" }
const _hoisted_28 = { class: "form-group-horizontal" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Name on meeting sign", -1)
const _hoisted_30 = { class: "form-control-value" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_32 = { class: "form-group-horizontal" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Date & time", -1)
const _hoisted_34 = { class: "form-control-value" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "special note", -1)
const _hoisted_38 = { class: "form-control-value font-weight-300" }
const _hoisted_39 = { class: "vehicle-location--controls" }

import { ref, onMounted, onUnmounted } from 'vue'
import { useIntervalFn } from '@vueuse/core'
import type { Booking } from "@/models/your-bookings"
import GoogleMap from "@/views/booking-details/GoogleMap.vue"
import BookingPaymentStatusLabel from "@/components/BookingPaymentStatusLabel.vue"
import CancelBookingModal from "@/views/booking-details/CancelBookingModal.vue"
import { useRoute, useRouter } from 'vue-router'
import { useUser } from '@/store/user'
import { useBooking } from '@/store/booking'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingsVehicleLocation',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const id = route.params.id as unknown as number

const { isCustomer } = useUser()
const { getBooking } = useBooking(id)

const booking = ref<Booking>()
const cancelModalVisible = ref(false)
const showBookingDetails = ref(false)

const fetchBooking = async () => {
  if (!isCustomer.value) {
    router.push({ name: 'booking_details', params: { id } })
  } else {
    booking.value = await getBooking()
  }
}

onMounted(fetchBooking)

const { pause } = useIntervalFn(fetchBooking, 5000)
onUnmounted(pause)

return (_ctx: any,_cache: any) => {
  const _component_UserPositionBar = _resolveComponent("UserPositionBar")!
  const _component_AppHeader = _resolveComponent("AppHeader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UserPositionBar),
    _createVNode(_component_AppHeader, {
      title: "vehicle location",
      "back-route-to": { name: 'bookings', query: _unref(route).query }
    }, null, 8, ["back-route-to"]),
    _createElementVNode("div", _hoisted_1, [
      (booking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(GoogleMap, { booking: booking.value }, null, 8, ["booking"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.vehicles, (v, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "vehicle-location--controls-driver",
                  key: k
                }, [
                  (v.driver)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(v.driver.nameLetters), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(v.driver.fullName), 1),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(v.driver.telNo1), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("a", {
                            href: 'tel:' + v.driver.telNo1,
                            class: "btn btn-primary btn-block btn-sm"
                          }, " Call Driver ", 8, _hoisted_10)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-block btn-md vehicle-location--controls-view-btn", { open: showBookingDetails.value }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showBookingDetails.value = !showBookingDetails.value), ["prevent"]))
              }, " view booking details ", 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (booking.value.driverVehicle)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: booking.value.driverVehicle.vehicle?.vehicleCat?.image
                        }, null, 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(booking.value.driverVehicle?.vehicle?.vehicleCat?.name) + " ", 1),
                    _createElementVNode("div", _hoisted_17, [
                      (booking.value.paymentStatus)
                        ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                            key: 0,
                            status: booking.value.paymentStatus
                          }, null, 8, ["status"]))
                        : _createCommentVNode("", true),
                      (booking.value.isCancelled)
                        ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                            key: 1,
                            status: "cancelled"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(booking.value.priceFormatted), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(booking.value.pickup), 1)
                  ]),
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(booking.value.destination), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString(booking.value.clientRef1), 1)
                ]),
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, _toDisplayString(booking.value.jobStartFormatted), 1)
                ]),
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, _toDisplayString(booking.value.pickupInstructions), 1)
                ])
              ]),
              (booking.value.canCustomerCancelBooking)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("button", {
                        class: "btn btn-block btn-cancel booking-details--btn-cancel",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (cancelModalVisible.value = true), ["prevent"]))
                      }, " Cancel booking ")
                    ]),
                    _createVNode(CancelBookingModal, {
                      show: cancelModalVisible.value,
                      booking: booking.value,
                      onClose: _cache[2] || (_cache[2] = ($event: any) => (cancelModalVisible.value = false)),
                      onCancelled: _unref(getBooking)
                    }, null, 8, ["show", "booking", "onCancelled"])
                  ], 64))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, showBookingDetails.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})